import MockAdapter from "axios-mock-adapter/types";
import getDocuments from "./responses/getDocuments";
import {
  URL_GET_DOCUMENT_PAYMENTS_TABLE,
  URL_GET_DOCUMENT_SERVICES_TABLE,
  URL_GET_DOCUMENTS_PAGED,
} from "@/requests/document";
import getServices from "./responses/getServices";
import getPayments from "./responses/getPayments";

export const documentsMock = (mock: MockAdapter): void => {
  mock.onGet(URL_GET_DOCUMENTS_PAGED).reply(200, getDocuments);
  mock.onGet(URL_GET_DOCUMENT_PAYMENTS_TABLE).reply(200, getPayments);
  mock.onGet(URL_GET_DOCUMENT_SERVICES_TABLE).reply(200, getServices);
};
